import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function AdminDeliveryOrders() {
  const [orders, setOrders] = useState([]);
  const [boys, setBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState({});
  const [loading, setLoading] = useState(true);
const [assigning, setAssigning] = useState({});
  const navigate = useNavigate();

  /* ---------------- LOAD DATA ---------------- */
  const loadData = async () => {
    try {
      const [orderRes, boyRes] = await Promise.all([
        axios.get("admin/delivery-orders/"),
        axios.get("admin/delivery-boys/"),
      ]);

      setOrders(orderRes.data.orders || []);
      setBoys(boyRes.data.delivery_boys || []);
    } catch {
      alert("Failed to load delivery data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
   const interval = setInterval(() => {
  if (!Object.values(assigning).includes(true)) {
    loadData();
  }
}, 15000); // auto refresh
    return () => clearInterval(interval);
  }, []);

  /* ---------------- ASSIGN DELIVERY BOY ---------------- */
const assignBoy = async (orderId) => {
  const boyId = selectedBoy[orderId];

  if (!boyId) {
    alert("Please select delivery boy");
    return;
  }

  // 🔒 prevent double click
  if (assigning[orderId]) return;

  try {
    setAssigning(prev => ({ ...prev, [orderId]: true }));

    const res = await axios.post("admin/assign-delivery/", {
      order_id: orderId,
      delivery_boy_id: boyId,
    });

    console.log("ASSIGN RESPONSE:", res);

    // ✅ ONLY real success
    if (res.data?.success === true) {
      alert("Delivery boy assigned");

      // reset dropdown
      setSelectedBoy(prev => ({
        ...prev,
        [orderId]: ""
      }));

      loadData();
      return;
    }

    // ❌ fallback safety
    alert("Assignment failed ❌");

  } catch (err) {
    console.log("Assign error:", err);

    const errorMsg =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      "Assignment failed ❌";

    alert(errorMsg);

  } finally {
    setAssigning(prev => ({ ...prev, [orderId]: false }));
  }
};
  if (loading) return <p style={{ padding: 20 }}>Loading...</p>;
	

  return (
    <div style={{ padding: 20 }}>
      <h2>🚚 Delivery Operations Panel</h2>

      {/* ---------------- DELIVERY BOYS STATUS ---------------- */}
      <h3>Delivery Boys (Live Status)</h3>

      {boys.map((boy) => (
        <div
          key={boy.id}
          style={{
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: 10,
            marginBottom: 10,
            background: boy.is_available ? "#ecfeff" : "#fef2f2",
          }}
        >
          <b>{boy.name}</b> ({boy.phone}) —{" "}
          {boy.active_orders >= 5 
  ? "🔴 Full" 
  : `🟢 ${(boy.active_orders ?? 0)}/${boy.max_orders || 5} Orders`}

          <button
            style={{
              marginLeft: 10,
              padding: "6px 12px",
              background: "#16a34a",
              color: "#fff",
              border: "none",
              borderRadius: 6,
            }}
            onClick={() =>
              navigate(`/admin/delivery-boy-map/${boy.id}`)
            }
          >
            Track
          </button>
        </div>
      ))}

      <hr style={{ margin: "30px 0" }} />

      {/* ---------------- ORDER ASSIGNMENT ---------------- */}
      <h3>Assign Orders</h3>

      <p style={{ opacity: 0.7 }}>
  No pending orders 🚀
</p>

      {orders.map((order) => (
        <div
          key={order.id}
          style={{
            border: "1px solid #ddd",
            borderRadius: 10,
            padding: 15,
            marginBottom: 15,
          }}
        >
          <h4>Order #{order.id}</h4>

          <p>
            <b>Customer:</b> {order.customer_name} ({order.phone})
          </p>

          <p>
            <b>Amount:</b> ₹{order.order_amount} |{" "}
            <b>Delivery:</b> ₹{order.delivery_charge}		
		<p>
		<b>Address:</b> {order.address || "No address"}
		</p>
          </p>

          <select
  value={selectedBoy[order.id] || ""}
  onChange={(e) =>
    setSelectedBoy({
      ...selectedBoy,
      [order.id]: e.target.value,
    })
  }
  disabled={["assigned", "out_for_delivery"].includes(order.status)}
  style={{
    padding: 8,
    marginRight: 10,
    background: ["assigned", "out_for_delivery"].includes(order.status)
      ? "#f3f4f6"   // light grey
      : "#fff",
    cursor: ["assigned", "out_for_delivery"].includes(order.status)
      ? "not-allowed"
      : "pointer",
  }}
>
            <option value="">Select Delivery Boy</option>
            {boys.map((b) => (
              <option
                key={b.id}
                value={b.id}
                disabled={(b.active_orders ?? 0) >= (b.max_orders || 5)}
              >
                {b.name} ({b.phone}) 
  		({(b.active_orders ?? 0)}/{b.max_orders || 5}) 
  		{b.active_orders >= 5 ? "🔴 Full" : "🟢"}
              </option>
            ))}
          </select>
<button
  onClick={() => assignBoy(order.id)}
  disabled={
    !selectedBoy[order.id] || 
    ["assigned", "out_for_delivery"].includes(order.status)
  }
  style={{
    padding: "8px 14px",
    background:
      ["assigned", "out_for_delivery"].includes(order.status)
        ? "#9ca3af"   // grey (disabled)
        : "#2563eb",  // blue (active)
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor:
      ["assigned", "out_for_delivery"].includes(order.status)
        ? "not-allowed"
        : "pointer",
  }}
>
  {["assigned", "out_for_delivery"].includes(order.status)
    ? "Assigned ✅"
    : "Assign"}
</button>





{order.status === "assigned" && (
  <button
    style={{
      marginLeft: 10,
      padding: "8px 14px",
      background: "#16a34a",
      color: "#fff",
      border: "none",
      borderRadius: 6,
    }}
    onClick={() =>
      navigate(`/admin/live-map/${order.id}`)
    }
  >
    Track Live
  </button>
)}


          
        </div>
      ))}
    </div>
  );
}
